module.exports = __webpack_public_path__ + "img/fruit-grapes-190x100.ca8b286d.jpg";